// extracted by mini-css-extract-plugin
export default {"root":"otherForm_root__e9ozW","paginationSection":"otherForm_paginationSection__jX+L2","pagination":"otherForm_pagination__i0nY6"};